import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)

// 动态加载 Layout 组件
const getLayoutComponent = () => {
  const customizedUniversity = localStorage.getItem('customized_university');  // 获取用户偏好设置
  // 根据 localStorage 中的值来决定加载哪个 Layout 组件
  if (customizedUniversity === 'szu') {
    return import('@/views/LayoutSzu.vue');
  } else if (customizedUniversity === 'gzjmzy') {
    return import('@/views/LayoutGzjmzy.vue');
  } else {
    return import('@/views/Layout.vue');  // 默认加载 LayoutDefault
  }
}

import { getLastPage,setLastPage, getToken, setToken, setSignKey, removeLastPage } from '@/utils/cache'

import HomeView from '@/views/HomeView.vue'
// import Layout from '@/views/Layout.vue'
import store from '@/store/index'
import { forceToSSO, getQueryString, jumpToSSO, removeStrBetween } from '@/utils/utils'
import { loginSSO } from '@/serves/api/signup'
import { pathUrl, testConfig } from '@/config'
import seoConfig, { defaultSeoConfig } from '@/config/seo'
import { writeMetaDescription } from '@/utils/dom'
import { joinSchool } from '@/views/JoinCampus/joinCampus'
// const Login = () => import('@/views/Login/index.vue')
// const Signup = () => import('@/views/Signup/index.vue')
const Profile = () => import('@/views/Profile/index.vue')

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err)
}

// 内置页面
const otherRoutes = [
  {
    path: '/ui',
    name: 'UI',
    component: () => import('@/views/MuiSamples.vue'),
    meta: {
      title: '组件库示例',
    },
  },
  // {
  //   path: '/rtl-test',
  //   name: 'RTLTest',
  //   component: () => import('@/views/RTLTest.vue'),
  //   meta: {
  //     title: 'RTL测试页面',
  //   },
  // },
  {
    path: '/icons',
    name: 'Icons',
    component: () => import('@/views/AllIcons.vue'),
    meta: {
      title: '图标库',
    },
  },
  {
    path: '/cert_verify/:check_code',
    name: 'scanResult',
    component: () => import('@/views/scan-result.vue'),
    meta: {
      title: '扫码结果',
    },
  },
  {
    path: '/pay/pay-result',
    name: 'payResult',
    component: () => import('@/views/pay-result.vue'),
    meta: {
      title: '支付结果',
    },
  },
  {
    path: '/about/index',
    name: 'About',
    component: () => import('@/views/AboutUs/index.vue'),
    meta: {
      title: '关于我们',
    },

  }
]

// 非路由页面
const innerRoutes = [
  // 个人信息
  {
    path: '/personal-center',
    name: 'perLayout',
    component: getLayoutComponent,
    meta: {
      needLogin: true,
    },
    children: [
      {
        path: '/personal-center/index',
        name: 'personalCenter',
        redirect: '/personal-center/index/personal-info',
        component: () =>
          import(
            /* webpackChunkName: "group-personal-center" */ '@/views/personalCenter/index.vue'
          ),
        children: [
          {
            path: '/personal-center/index/personal-info',
            name: 'personalInfo',
            component: () =>
              import(
                /* webpackChunkName: "group-personal-center" */ '@/views/personalCenter/personalInfo.vue'
              ),
            meta: {
              title: '个人信息',
            },
            // children: [
            //   {
            //     path: "/personal-center/index/personal-info/delete-user",
            //     name: "deleteUser",
            //     component: () =>
            //       import(/* webpackChunkName: "group-delete-user" */ "@/views/personalCenter/deleteUser.vue"),
            //     meta: {
            //       title: "注销账号",
            //     },
            //   },
            // ],
          },
          {
            path: '/personal-center/index/delete-user',
            name: 'deleteUser',
            component: () =>
              import(
                /* webpackChunkName: "group-delete-user" */ '@/views/personalCenter/deleteUser.vue'
              ),
            meta: {
              title: '注销账号',
            },
          },
          {
            path: '/personal-center/index/mywallet',
            name: 'myWallet',
            redirect: '/personal-center/index/mywallet/recharge',
            component: () =>
              import(
                /* webpackChunkName: "group-personal-center" */ '@/views/personalCenter/myWallet.vue'
              ),

            children: [
              {
                path: '/personal-center/index/mywallet/recharge',
                name: 'recharge',
                component: () =>
                  import(
                    /* webpackChunkName: "group-personal-center" */ '@/views/personalCenter/recharge.vue'
                  ),
                meta: {
                  title: '我的购买',
                },
              },
              {
                path: '/personal-center/index/mywallet/consume',
                name: 'consume',
                component: () =>
                  import(
                    /* webpackChunkName: "group-personal-center" */ '@/views/personalCenter/consume.vue'
                  ),
                meta: {
                  title: '我的购买',
                },
              },
            ],
          },
          {
            path: '/personal-center/index/learn-history',
            name: 'learnHistory',
            component: () =>
              import(
                /* webpackChunkName: "group-personal-center" */ '@/views/personalCenter/learnHistory.vue'
              ),
            meta: {
              title: '学习记录',
            },
          },
          {
            path: '/personal-center/index/management',
            name: 'management',
            component: () =>
              import(
                /* webpackChunkName: "group-personal-center" */ '@/views/personalCenter/management.vue'
              ),
            meta: {
              title: '管理',
              roles: ['admin', 'editor'],
            },
          },
          {
            path: '/personal-center/index/edit-message',
            name: 'editMessage',
            component: () =>
              import(
                /* webpackChunkName: "group-personal-center" */ '@/views/personalCenter/editMessage.vue'
              ),
            meta: {
              title: '编辑通知',
              roles: ['admin', 'editor'],
            },
          },
        ],
      },
      {
        path: '/personal-center/manual-correction',
        name: 'manualCorrection',
        component: () =>
          import(
            /* webpackChunkName: "group-personal-center" */ '@/views/personalCenter/manualCorrection.vue'
          ),
        meta: {
          title: '人工批改',
          roles: ['admin', 'writer'],
        },
      },
      {
        path: '/personal-center/mark-details',
        name: 'markDetails',
        component: () =>
          import(
            /* webpackChunkName: "group-personal-center" */ '@/views/personalCenter/markDetails.vue'
          ),
        meta: {
          title: '批改详情',
        },
      },
      {
        path: '/personal-center/my-class',
        name: 'myClass',
        component: () =>
          import(
            /* webpackChunkName: "group-personal-center" */ '@/views/personalCenter/myClass.vue'
          ),
        meta: {
          title: '我的班级',
        },
      },
      {
        path: '/personal-center/my-assignment',
        name: 'MyAssignment',
        component: () =>
          import(
            /* webpackChunkName: "group-personal-center" */ '@/views/personalCenter/myAssignment.vue'
          ),
        meta: {
          title: '我的作业',
          roles: ['admin', 'editor', 'teacher', 'marker', 'writer'],
        },
      },
      {
        path: '/personal-center/assignment-detail',
        name: 'AssignmentDetail',
        component: () =>
          import(
            /* webpackChunkName: "group-personal-center" */ '@/views/personalCenter/assignmentDetail.vue'
          ),
        meta: {
          title: '作业详情',
          roles: ['admin', 'editor', 'teacher', 'marker', 'writer'],
        },
      },
      {
        path: '/personal-center/add-assignment',
        name: 'AddAssignment',
        component: () =>
          import(
            /* webpackChunkName: "group-personal-center" */ '@/views/personalCenter/addAssignment.vue'
          ),
        meta: {
          title: '布置作业',
          roles: ['admin', 'editor', 'teacher', 'marker', 'writer'],
        },
      },
      {
        path: '/personal-center/stu-assignment',
        name: 'StuAssignment',
        component: () =>
          import(
            /* webpackChunkName: "group-personal-center" */ '@/views/personalCenter/studentMyAssignment.vue'
          ),
        meta: {
          title: '我的作业', //学生
          roles: ['learner'],
        },
      },
    ],
  },
  // // 登录
  // {
  //   path: '/login',
  //   name: 'Login',
  //   component: Login,
  //   meta: {
  //     title: '登录',
  //   },
  // },
  // // 注册
  // {
  //   path: '/signup',
  //   name: 'Signup',
  //   component: Signup,
  //   meta: {
  //     title: '注册',
  //   },
  // },
  // 完善个人信息
  {
    path: '/profile',
    name: 'Profile',
    component: getLayoutComponent,
    meta: {
      title: '完善个人信息',
      needLogin: true,
    },
    children: [
      {
        path: '/profile/:step',
        name: 'ProfileStep',
        component: Profile,
      },
    ],
  },
  // 关于我们
  {
    path: '/about',
    // name: 'AboutUs',
    component: getLayoutComponent,
    // redirect: '/about/info',
    meta: {
      title: '关于我们',
    },
    children: [
      {
        // path: '/about/info',
        path: '',
        name: 'AboutInfo',
        component: () => import('@/views/AboutUs/info.vue'),
      },
    ],
  },
  // 意见反馈
  {
    path: '/feedback',
    // name: 'Feedback',
    component: getLayoutComponent,
    // redirect: '/feedback/index',
    meta: {
      title: '意见反馈',
    },
    children: [
      {
        // path: '/feedback/index',
        path: '',
        name: 'FeedbackIndex',
        component: () => import('@/views/Feedback/index.vue'),
      },
    ],
  },
  // 隐私协议
  {
    path: '/privacy',
    name: 'Privacy',
    component: getLayoutComponent,
    redirect: '/privacy/index',
    meta: {
      title: '隐私协议',
    },
    children: [
      {
        path: '/privacy/index',
        name: 'PrivacyIndex',
        component: () => import('@/views/PrivacyPolicy/index.vue'),
      },
    ],
  },
  {
    path: '/pay',
    name: 'Pay',
    component: getLayoutComponent,
    redirect: '/pay/index',
    meta: {
      title: '支付详情页',
    },
    children: [
      {
        path: '/pay/index',
        name: 'PayIndex',
        component: () => import('@/views/Pay/index.vue'),
      },
    ],
  },
  {
    path: '/pay/repay',
    name: 'rePay',
    component: getLayoutComponent,
    redirect: '/pay/repay',
    meta: {
      title: '支付详情页',
    },
    children: [
      {
        path: '/pay/repay',
        name: 'PayRePay',
        component: () => import('@/views/Pay/repay.vue'),
      },
    ],
  },
  {
    path: '/pay/wxpay',
    name: 'wxPay',
    component: getLayoutComponent,
    redirect: '/pay/wxpay/index',
    meta: {
      title: '微信支付',
    },
    children: [
      {
        path: '/pay/wxpay/index',
        name: 'wxPayIndex',
        component: () => import('@/views/Pay/wxpay.vue'),
      },
    ],
  },
]

// 路由菜单页面
// group 1:首页 3:全真模拟 4:免费样卷 5: 词汇大纲
const menuRoutes = [
  // 首页
  {
    path: '*',
    name: 'Home',
    component: getLayoutComponent,
    redirect: '/home/index',
    meta: {
      menu: 'home',
      title: '首页',
    },
    children: [
      {
        path: '/home/index',
        name: 'HomeIndex',
        component: HomeView,
      },
    ],
  },
  // 深圳大学
  {
    path: '/szu',
    name: 'Szu',
    component: getLayoutComponent,
    meta: {
      menu: 'szu',
      title: '首页',
    },
    children: [
      {
        path: '/szu',
        name: 'HomeSzu',
        component: () =>
          import('@/views/University/szu.vue'),
      },
    ],
  },
  // 贵州经贸
  {
    path: '/gzjmzy',
    name: 'Gzjmzy',
    component: getLayoutComponent,
    meta: {
      menu: 'gzjmzy',
      title: '首页',
    },
    children: [
      {
        path: '/gzjmzy',
        name: 'HomeGzjmzy',
        component: () =>
          import('@/views/University/gzjmzy.vue'),
      },
    ],
  },
  // 等级选择
  {
    path: '/chooselevel',
    name: 'levelLayout',
    component: getLayoutComponent,
    redirect: '/chooselevel/index',
    meta: {
      title: '等级选择',
    },
    children: [
      {
        path: '/chooselevel/index',
        name: 'ChooseLevel',
        component: () =>
          import(/* webpackChunkName: "choose-level" */ '@/views/ChooseLevel/index.vue'),
      },
    ],
  },
  // 模拟考
  {
    path: '/hsk',
    name: 'hskLayout', //name值更改时全局判断下，hsk模考的权限基于name判定
    component: getLayoutComponent,
    redirect: '/hsk/tests',
    meta: {
      // needLogin: true,
      menu: 'mock',
      title: '全真模拟',
    },
    children: [
      {
        path: '/hsk/tests',
        name: 'HSKExamination',
        component: () => import(/* webpackChunkName: "group-hsk" */ '@/views/hsk/index.vue'),
      },
      {
        path: '/new-hsk/tests',
        name: 'HSKExamination',
        component: () => import(/* webpackChunkName: "group-hsk" */ '@/views/hsk/index.vue'),
      },
      {
        path: '/hskk/tests',
        name: 'HSKKExamination',
        component: () => import(/* webpackChunkName: "group-hsk" */ '@/views/hsk/index.vue'),
      },
      {
        path: '/new-hskk/tests',
        name: 'HSKKExamination',
        component: () => import(/* webpackChunkName: "group-hsk" */ '@/views/hsk/index.vue'),
      },
      {
        path: '/yct/tests',
        name: 'YCTExamination',
        component: () => import(/* webpackChunkName: "group-hsk" */ '@/views/hsk/index.vue'),
      },
      {
        path: '/hsk/index',
        redirect:'/hsk/tests',
      },
      {
        path: '/new-hsk/index',
        redirect:'/new-hsk/tests',
      },
      {
        path: '/hskk/index',
        redirect:'/hskk/tests',
      },
      {
        path: '/new-hskk/index',
        redirect:'/hskk/tests',
      },
      {
        path: '/yct/index',
        redirect:'/yct/tests',
      },
      {
        path: '/hsk/introduce',
        name: 'Introduce',
        component: () => import(/* webpackChunkName: "group-hsk" */ '@/views/hsk/Introduce.vue'),
        meta: {
          needLogin: true,
        },
      },
      {
        path: '/hsk/about',
        name: 'HskAbout',
        component: () => import(/* webpackChunkName: "group-hsk" */ '@/views/hsk/about.vue'),
        meta: {},
      },
      {
        path: '/hskk/about',
        name: 'HskkAbout',
        component: () => import(/* webpackChunkName: "group-hsk" */ '@/views/hsk/about.vue'),
        meta: {},
      },
      {
        path: '/yct/about',
        name: 'HskAbout',
        component: () => import(/* webpackChunkName: "group-hsk" */ '@/views/hsk/about.vue'),
        meta: {},
      },
      {
        path: '/hsk/levelReport',
        name: 'levelReport',
        component: () => import(/* webpackChunkName: "group-hsk" */ '@/views/hsk/levelReport.vue'),
        meta: {
          needLogin: true,
        },
      },
      {
        path: '/hsk/syllabuses',
        name: 'syllabuses',
        component: () => import(/* webpackChunkName: "group-hsk" */ '@/views/hsk/syllabuses.vue'),
        meta: {
          needLogin: true,
        },
      },
      {
        path: '/hsk/examinationUpgrade',
        name: 'ExaminationUpgrade',
        component: () =>
          import(/* webpackChunkName: "group-hsk" */ '@/views/hsk/examinationUpgrade.vue'),
        meta: {
          menu: 'online',
          title: '免费样卷',
          needLogin: true,
        },
      },
      {
        path: '/hsk/resultReport',
        name: 'ResultReport',
        component: () => import(/* webpackChunkName: "group-hsk" */ '@/views/hsk/resultReport.vue'),
        meta: {
          needLogin: true,
        },
      },
      {
        path: '/hsk/simulation',
        name: 'Simulation',
        component: () => import(/* webpackChunkName: "group-hsk" */ '@/views/hsk/simulation.vue'),
        meta: {
          needLogin: true,
        },
      },
      {
        path: '/hsk/simulationHigh',
        name: 'SimulationHigh',
        component: () => import(/* webpackChunkName: "group-hsk" */ '@/views/hsk/simulationHigh.vue'),
        meta: {
          needLogin: true,
        },
      },
      {
        // hsk 3.0版本模板
        path: '/hsk/simulationTri',
        name: 'SimulationTri',
        component: () => import(/* webpackChunkName: "group-hsk" */ '@/views/hsk/simulationTri.vue'),
        meta: {
          needLogin: true,
        },
      },
      {
        path: '/hsk/simulationHskk',
        name: 'SimulationHskk',
        component: () => import(/* webpackChunkName: "group-hsk" */ '@/views/hsk/simulationHskk.vue'),
        meta: {
          needLogin: true,
        },
      },
      {
        path: '/hsk/priceForm',
        name: 'priceForm',
        component: () => import(/* webpackChunkName: "group-hsk" */ '@/views/hsk/priceForm.vue'),
        meta: {
          needLogin: false,
        },
      },
    ],
  },
  // 在线练习
  {
    path: '/hsk/onlinePractice',
    name: 'OnlinePractice',
    component: getLayoutComponent,
    redirect: '/hsk/onlinePractice/index',
    meta: {
      menu: 'online',
      title: '免费样卷',
    },
    children: [
      {
        path: '/hsk/onlinePractice/index',
        name: 'OnlinePracticeIndex',
        component: () =>
          import(/* webpackChunkName: "group-hsk" */ '@/views/hsk/onlinePractice.vue'),
      },
    ],
  },
  // 水平测
  {
    path: '/spc',
    name: 'spcLayout',
    component: getLayoutComponent,
    redirect: '/spc/home',
    meta: {
      needLogin: true,
      title: '水平测试',
    },
    children: [
      {
        path: '/spc/home',
        name: 'spcHome',
        component: () => import(/* webpackChunkName: "group-spc" */ '@/views/spc/home.vue'),
        meta: {
          keepAlive: false,
        },
      },
      {
        path: '/spc/examination',
        name: 'spcExamination',
        component: () => import(/* webpackChunkName: "group-spc" */ '@/views/spc/examination.vue'),
        meta: {
          keepAlive: false,
        },
      },
            {
        path: '/spc/mobileGuidances',
        name: 'spcMobileGuidances',
        component: () => import(/* webpackChunkName: "group-spc" */ '@/views/spc/mobileGuidances.vue'),
        meta: {
          keepAlive: false,
        },
      },
    ],
  },
  // 词汇
  {
    path: '/vocabulary',
    name: 'vocab',
    component: getLayoutComponent,
    meta: {
      menu: 'vocabulary',
      title: '词汇检测',
    },
    children: [
      {
        path: '/vocabulary/index',
        name: 'vocabulary',
        component: () =>
          import(/* webpackChunkName: "group-vocabulary" */ '@/views/vocabulary/index.vue'),
      },
    ],
  },
  // 合伙人表单
  {
    path: '/PartnerForms',
    name: 'PartnerForms',
    component: getLayoutComponent,
    redirect: '/PartnerForms/index',
    meta: {
      title: '合伙人表单',
    },
    children: [
      {
        path: '/partnerforms/index',
        name: 'PartnerFormsIndex',
        component: () => import('@/views/PartnerForms/index.vue'),
      },
    ],
  },
  {
    path: '/solutions',
    // name: 'Solutions',
    component: getLayoutComponent,
     // redirect: '/forTeachers/index',
    meta: {
      title: '教师表单',
    },
    children: [
      {
        // path: '/forTeachers/index',
        path: '',
        // name: 'ForTeachersIndex',
        name: 'SolutionsIndex',
        component: () => import('@/views/ForTeachers/ForTeachers.vue'),
      },
    ],
  },

  // 添加学校
  {
    path: '/addSchool',
    name: 'AddSchool',
    component: getLayoutComponent,
    redirect: '/addSchool/index',
    meta: {
      title: '学校表单',
    },
    children: [
      {
        path: '/addSchool/index',
        name: 'AddSchoolIndex',
        component: () => import('@/views/ForTeachers/addSchool.vue'),
      },
    ],
  },
  // 买一赠一
  // payDiscounts/index?type=hsk&level=4
  {
    path: '/payDiscounts',
    name: 'PayDiscounts',
    component: getLayoutComponent,
    redirect: '/payDiscounts/index',
    meta: {
      title: '买一赠一',
    },
    children: [
      {
        path: '/payDiscounts/index',
        name: 'PayDiscountsIndex',
        component: () => import('@/views/Pay/PayDiscounts.vue'),
      },
    ],
  },
    {
    path: '/joinCampus',
    name: 'JoinCampus',
    component: getLayoutComponent,
    redirect: '/JoinCampus/index',
    meta: {
      title: '加入学校',
    },
    children: [
      {
        path: '/joinCampus/index/:schoolCode',
        name: 'JoinCampusIndex',
        component: () => import('@/views/JoinCampus/index.vue'),
      },
    ],
  },
]

const router = new VueRouter({
  mode: 'history',
  routes: [...menuRoutes, ...innerRoutes, ...otherRoutes],
})


const handleFromSSOLoginJump = async () => { // 登录回来都跳转到原来页面
  const lastPage = getLastPage()
  if (!lastPage) { return }
  let jumpUrl = lastPage

  if (lastPage.includes('joinCampus/index')) { // 调用加入学校
   await joinSchool(lastPage).then(res => {
      jumpUrl = ''
    }).catch(err => {
      console.log(err)
      jumpUrl = lastPage
    })
  }
  removeLastPage()
  jumpUrl && router.push({ path: jumpUrl })
}

const handleFromSSOSignUpJump = async (missingPart) => {  // 注册回来只有特殊处理的跳转到原来页面
  const lastPage = getLastPage()
  if (!lastPage) { return }
  let jumpUrl = `/profile/${missingPart}`
  if (lastPage.includes('joinCampus/index')) { // 调用加入学校
    await joinSchool(lastPage).catch(err => {
      jumpUrl = lastPage
    })
  }
  removeLastPage()
  jumpUrl && router.push({ path: jumpUrl })
}


const parseSSO = (code, ticket) => {
  return new Promise((resolve, reject) => {
    console.log('code', code)
    console.log('ticket', ticket)
    console.log('isParsingLoginCode', store.state.user.isParsingLoginCode)
    if (store.state.user.isParsingLoginCode) {
      resolve()
      return
    }
    store.state.user.isParsingLoginCode = true
    if (code && ticket) {
      let url = decodeURIComponent(window.location.origin + window.location.pathname)
      // if (process.env.VUE_APP_MODE == 'dev') {
      //   // 本地测试使用的值
      //   url = pathUrl.MOCK
      // }
      console.log('url地址', url)
      loginSSO({
        code: code,
        ticket: ticket,
        redirect_uri: url,
      })
        .then((response) => {
          const token = response?.data?.token?.access_token
          const signKey = response?.data?.sign_key
          if (token) {
            setToken(token)
            store.dispatch('user/checkIsFreeTest').then(() => {
              console.log('checkIsFreeTest')
            })
          }
          if (signKey) {
            setSignKey(signKey)
          }

          const missingPart = response?.data?.missing_part
          if (missingPart) {
            handleFromSSOSignUpJump(missingPart)
          } else {
            //登录成功拿到userid，注册用户埋点
            store.dispatch('user/refreshUser').then(() => {
              handleFromSSOLoginJump()
            })
          }
          resolve()
        })
        .catch((errmsg) => {
          console.log('登录失败', errmsg)
          //登录失败
          // Message({ type: 'error', message: errmsg || t('log_in_error') })
          forceToSSO(errmsg)
          reject(errmsg)
        })
        .finally(() => {})
    }
  })
}
const testConfigReverse = Object.fromEntries(
  Object.entries(testConfig).map((item) => item.reverse())
)
// HSKExamination  YCTExamination
const setSeoTitle = (name, query) => {
  const levelId = localStorage.getItem('LevelActiveId')
  const levelType = localStorage.getItem('LevelType')
  let key = `${testConfigReverse[levelType]} ${levelId}`
  switch (name) {
    case 'HomeIndex':
      for (let item of seoConfig) {
        if (item.name === 'HomeIndex') {
          document.title = item.title
          writeMetaDescription(item.description)
          break
        }
      }
      break
    case 'HSKExamination':
      console.log(123123123)
      key = `HSKE ${levelId}`
      for (let item of seoConfig) {
        if (item.key === key) {
          document.title = item.title
          writeMetaDescription(item.description)
          break
        }
      }
      break
    case 'YCTExamination':
      key = `YCT ${levelId}`
      for (let item of seoConfig) {
        if (item.key === key) {
          document.title = item.title
          writeMetaDescription(item.description)
          break
        }
      }
      break
    case 'HskAbout':
      for (let item of seoConfig) {
        if (item.key === key) {
          document.title = item.title
          writeMetaDescription(item.description)
          break
        }
      }
      break
    case 'spcExamination':
      for (let item of seoConfig) {
        if (item.name === 'spcExamination') {
          document.title = item.title
          writeMetaDescription(item.description)
          break
        }
      }
      break
    case 'ChooseLevel':
      for (let item of seoConfig) {
        if (item.name === 'ChooseLevel') {
          document.title = item.title
          writeMetaDescription(item.description)
          break
        }
      }
      break
    case 'AboutInfo':
      for (let item of seoConfig) {
        if (item.name === 'AboutInfo') {
          document.title = item.title
          writeMetaDescription(item.description)
          break
        }
      }
      break
    default:
      document.title = defaultSeoConfig.title
      writeMetaDescription(defaultSeoConfig.description)
  }
}

router.beforeEach(async (to, from, next) => {
  // 判断 customizedUniversity
  const customizedUniversity = localStorage.getItem('customized_university');  // 获取用户偏好设置
  // 深圳大学
  if (customizedUniversity === 'szu' && (to.path == '/' || to.path == '/home/index')) {
    return next('/szu');  // 如果是 szu，且不是访问 /szu 页面，重定向到 /szu
  }
  if (customizedUniversity === 'gzjmzy' && (to.path == '/' || to.path == '/home/index')) {
    return next('/gzjmzy');  // 如果是 gzjmzy，且不是访问 /gzjmzy 页面，重定向到 /gzjmzy
  }
  setSeoTitle(to.name, to.query)
  // 如果跳出当前域名，重定向到首页
  if (!document.referrer || !document.referrer.includes(location.host)) {
    const { origin, pathname, search } = location
    location.href = `${origin}${pathname}${search}`
    return
  }
  let code = getQueryString('code')
  let ticket = getQueryString('ticket')
  if (code && ticket) { // 从sso跳转回
    await parseSSO(code, ticket)
    store.state.user.isParsingLoginCode = false
  }
  // 考试过程中的页面禁用语言和货币选择
  const simulationPageNames = ['Simulation', 'SimulationHigh', 'SimulationTri', 'SimulationHskk']
  if (simulationPageNames.includes(to.name)) {
    store.dispatch('grade/inGradingPage', true)
  } else {
    store.dispatch('grade/inGradingPage', false)
  }
  // queryToken && setToken(queryToken)
  const token = getToken()
  // 判断是否需要登录
  const needLogin = !!to?.matched?.some((item) => !!item?.meta?.needLogin)
  if (needLogin && !token) {
    setLastPage(to.fullPath)
    // next("/login");
    // 跳转到sso登录页
    let verified = jumpToSSO()
    if (verified) {
      // 进入邮箱验证页面
      next()
    }
  } else {
    //页面角色判断
    if (to.meta.roles) {
      const role = store.state.user.role
      if (to.meta.roles.includes(role)) {
        next()
      } else {
        next('/')
      }
    } else {
      next()
    }
  }
})

router.afterEach((to, from) => {
  // console.log('afterEach to from :')
  let href = window.location.search
  if (href.includes('ticket') && href.includes('code')) {
    let url = ''
    url = removeStrBetween(window.location.href, [
      ['code=', '&'],
      ['ticket=', '&'],
      ['state=', '&'],
    ])
    let arr = url.split('?')
    console.log('arr/////////')
    console.log(arr)
    if (!arr[1]) {
      // 最后一个字符为 ？
      url = arr[0]
    }
    console.log('删除后的url', url)
    // 异步执行 否则清不掉
    window.history.replaceState({}, '', url)
    return
  }
})
export default router

